<template>
  <div class="safeguarding-page">
    <div class="container content">
      <div class="tabs-wrapper">
        <div class="tabs-row">
          <button class="tab-btn" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
            <span v-if="font_type == 1">Safeguarding &amp; Child Protection</span>
            <span v-if="font_type == 2">ဘေးကင်းလုံခြုံရေးနှင့် ကလေးသူငယ်ကာကွယ်စောင့်ရှောက်ရေး</span>
          </button>
          <button class="tab-btn" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
            <span v-if="font_type == 1">Wellbeing</span>
            <span v-if="font_type == 2">ကိုယ်စိတ်နှလုံး ကျန်းမာပျော်ရွှင်ရေး</span>
          </button>
          <button class="tab-btn" :class="{ active: activeTab === 3 }" @click="activeTab = 3">
            <span v-if="font_type == 1">Counselling</span>
            <span v-if="font_type == 2">အကြံပေးဆွေးနွေးမှုနှင့် စိတ်ပိုင်းဆိုင်ရာ ပံ့ပိုးကူညီမှု</span>
          </button>
        </div>
        <div class="tabs-bottom-border"></div>
      </div>

      <div class="content-card shadow-lg rounded-lg">
        <div v-if="font_type == 1">
          <h2 v-if="activeTab === 1" class="card-title">Safeguarding &amp; Child Protection</h2>
          <h2 v-if="activeTab === 2" class="card-title">Wellbeing</h2>
          <h2 v-if="activeTab === 3" class="card-title">Counselling</h2>

          <img v-if="activeTab === 1" class="card-image" src="./../assets/img/safegurding/Adolecent.jpg"
            alt="Safeguarding &amp; Child Protection" />
          <img v-if="activeTab === 2" class="card-image" src="./../assets/img/safegurding/Wellbeing.jpg"
            alt="Wellbeing" />
          <img v-if="activeTab === 3" class="card-image" src="./../assets/img/safegurding/counselling.jpg"
            alt="Counselling" />

          <div v-if="activeTab === 1" class="english-content">
            <p class="text-justify">At Shwe Maw Kun Private School, we believe that the welfare of our students is
              paramount and that safeguarding is the shared responsibility of every member of our community. Our robust
              Child Protection Policy is strictly aligned with international standards and the UN Convention on the
              Rights of the Child to ensure a safe and supportive learning environment. To uphold these high standards,
              our teaching staff have successfully completed accredited training through TES courses, which provide
              high-quality, up-to-date content in safeguarding and wellbeing. Every staff member undergoes this
              mandatory professional training and utilizes advanced systems like CPOMS for secure incident reporting,
              tracking, and the protected storage of all safeguarding records. By maintaining strict professional
              boundaries and clear reporting protocols, we guarantee a secure space where every child can focus on their
              growth and development. Our unwavering commitment to student safety remains our highest priority as we
              strive to provide a world-class educational experience.</p>
            <p class="text-justify">Furthermore, to ensure a culture of vigilance from day one, all new staff members
              undergo comprehensive safeguarding and child protection training during their induction. This onboarding
              process ensures that every educator and support staff member fully understand the school's advanced
              safeguarding systems, recognizes their specific responsibilities, and is expertly equipped to identify
              signs of possible abuse or neglect. To maintain the highest standards of safety, this training is
              conducted annually and is consistently updated to remain in line with current global best practices and
              evolving international standards. This rigorous approach guarantees that our team remains proactive and
              highly skilled in protecting the wellbeing of every student in our care.</p>
          </div>

          <div v-if="activeTab === 2" class="english-content">
            <p class="text-justify">At Shwe Maw Kun Private School, we are deeply committed to the holistic wellbeing of
              our entire community, ensuring both students and staff thrive in a supportive environment. We employ
              advanced digital systems that specifically cover diverse wellbeing topics to proactively address the
              social and emotional needs of our school. Our professional incident reporting and tracking protocols
              ensure that every concern is monitored closely to provide effective and ongoing support. This framework is
              carefully customized to our local context, maintaining full compliance with Myanmar laws and global
              international standards. To maintain total confidentiality, we utilize secure data protection measures for
              the storage of all safeguarding and wellbeing records. By prioritizing a strong cultural fit, we ensure
              our wellbeing initiatives remain perfectly aligned with our school's core values and community
              expectations.</p>
          </div>

          <div v-if="activeTab === 3" class="english-content">
            <p class="text-justify">At Shwe Maw Kun Private School, we further prioritize student mental health by
              providing a dedicated professional counsellor on every campus. This initiative creates a trusted and safe
              environment where students feel empowered to openly share their feelings and receive personalized
              emotional support whenever needed. By having on-site experts, we ensure a deep Wellbeing Focus that is
              directly integrated into our daily campus life. This approach provides Ongoing Support for our students,
              aligning perfectly with our school values and community expectations for a supportive Cultural Fit.
              Furthermore, these interactions are managed with the highest standards of Data Protection, ensuring all
              student disclosures are handled with professional confidentiality and care. This comprehensive counselling
              network reinforces our commitment to Safeguarding Compliance, maintaining a nurturing and safe atmosphere
              for every child's growth.</p>
          </div>
        </div>

        <div v-if="font_type == 2">
          <h2 v-if="activeTab === 1" class="card-title">ဘေးကင်းလုံခြုံရေးနှင့် ကလေးသူငယ်ကာကွယ်စောင့်ရှောက်ရေး</h2>
          <h2 v-if="activeTab === 2" class="card-title">ကိုယ်စိတ်နှလုံး ကျန်းမာပျော်ရွှင်ရေး</h2>
          <h2 v-if="activeTab === 3" class="card-title">အကြံပေးဆွေးနွေးမှုနှင့် စိတ်ပိုင်းဆိုင်ရာ ပံ့ပိုးကူညီမှု</h2>

          <img v-if="activeTab === 1" class="card-image" src="./../assets/img/safegurding/Adolecent.jpg"
            alt="ဘေးကင်းလုံခြုံရေးနှင့် ကလေးသူငယ်ကာကွယ်စောင့်ရှောက်ရေး" />
          <img v-if="activeTab === 2" class="card-image" src="./../assets/img/safegurding/Wellbeing.jpg"
            alt="ကိုယ်စိတ်နှလုံး ကျန်းမာပျော်ရွှင်ရေး" />
          <img v-if="activeTab === 3" class="card-image" src="./../assets/img/safegurding/counselling.jpg"
            alt="အကြံပေးဆွေးနွေးမှုနှင့် စိတ်ပိုင်းဆိုင်ရာ ပံ့ပိုးကူညီမှု" />

          <div v-if="activeTab === 1" class="burmese-content">
            <p class="text-justify myanmar-text">ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်းတွင် ကျောင်းသား၊ ကျောင်းသူတိုင်း၏
              ဘေးကင်းလုံခြုံရေးနှင့် ကျန်းမာပျော်ရွှင်စွာ ဖွံ့ဖြိုးတိုးတက်ရေးကို အဓိကဦးစားပေး ပါသည်။ ကျောင်းသား၊
              ကျောင်းသူများကို ကာကွယ်စောင့်ရှောက်ခြင်းသည် ကျောင်းနှင့် သက်ဆိုင်သူအားလုံးက အတူတကွ တာဝန်ယူရမည့်
              အရေးကြီးသော တာဝန်တစ်ရပ်ဖြစ်သည်ဟု အလေးအနက် ယုံကြည်ပါသည်။</p>
            <p class="text-justify myanmar-text">ကလေးသူငယ်ကာကွယ်စောင့်ရှောက်ရေးမူဝါဒ (Safeguarding and Child Protection
              Policy) သည် နိုင်ငံတကာစံနှုန်းများနှင့် ကုလသမဂ္ဂ၏ ကလေးသူငယ်အခွင့်အရေးဆိုင်ရာ သဘောတူစာချုပ် (UN Convention
              on the Rights of the Child) တို့နှင့်အညီ ရေးဆွဲထားပြီး ကလေးတိုင်း လုံခြုံစိတ်ချရသော
              သင်ယူမှုပတ်ဝန်းကျင်တွင် ပညာသင်ယူဖွံ့ဖြိုးနိုင်ရန် ရည်ရွယ်ပါသည်။</p>
            <p class="text-justify myanmar-text">ဤစံနှုန်းများကို ထိန်းသိမ်းနိုင်ရန် ကျောင်းရှိဆရာ၊ ဆရာမများသည် Online
              Learning Platform တစ်ခုဖြစ်သော TES မှ အသိအမှတ်ပြုထားသော သင်တန်းများကို တက်ရောက်ရပါသည်။ Tes Develop သည် UK
              အခြေစိုက် Tes (Times Educational Supplement) ရဲ့ online learning / professional development platform
              တစ်ခုဖြစ်ပြီး အဓိကအားဖြင့် ဆရာ၊ဆရာမများနှင့် ဝန်ထမ်းများအတွက် CPD (Continuing Professional Development)
              သင်တန်းများပို့ချပေးသော platform ဖြစ်ပါသည်။ ကလေးသူငယ်ကာကွယ်စောင့်ရှောက်ရေးနှင့် ဘေးကင်းလုံခြုံရေးဆိုင်ရာ
              အသိပညာနှင့် ကျွမ်းကျင်မှုများကိုလည်း မြှင့်တင်လျက်ရှိပါသည်။</p>
            <p class="text-justify myanmar-text">ကလေးသူငယ်ကာကွယ်စောင့်ရှောက်ရေးနှင့် သက်ဆိုင်သော ဖြစ်စဉ်များကို
              လုံခြုံစွာ မှတ်တမ်းတင်ခြင်း၊ အချိန်မီတင်ပြနိုင်ခြင်း၊ နောက်ဆက်တွဲဆောင်ရွက်မှုများကို စောင့်ကြည့်ခြင်းနှင့်
              သက်ဆိုင်ရာမှတ်တမ်းများကို လုံခြုံစွာ သီးသန့်သိမ်းဆည်းခြင်းတို့အတွက် လုံခြုံစိတ်ချရသည့် Child Protection
              Online Monitoring System (CPOMs) ကိုအသုံးပြုပါသည်။ ထို့အပြင် ဆရာ၊ ဆရာမများနှင့် ကျောင်းသား၊
              ကျောင်းသူများအကြား ထားရှိရမည့်စည်းမျဉ်းများ၊ စိုးရိမ်ဖွယ်ရာဖြစ်စဉ်များကို အချိန်မီ တင်ပြနိုင်ရန်နှင့်
              ဖြစ်ပေါ်လာနိုင်သည့် အန္တရာယ်များကို ကြိုတင် ကာကွယ်တားဆီးနိုင်ရန် တိကျသော လမ်းညွှန်ချက်များနှင့်
              အစီရင်ခံတင်ပြမှုဆိုင်ရာ လုပ်ထုံးလုပ်နည်းများကို စနစ်တကျ ချမှတ်ထားပါသည်။</p>
            <p class="text-justify myanmar-text">ဝန်ထမ်းအသစ်များသည် ကျောင်းသို့ စတင်ဝင်ရောက်သည့် ပထမနေ့မှစ၍
              ကလေးသူငယ်ကာကွယ်စောင့်ရှောက်ရေးနှင့် ဘေးကင်းလုံခြုံရေးဆိုင်ရာ အခြေခံမိတ်ဆက်သင်တန်း (Safeguarding and Child
              Protection Induction Training) ကို မဖြစ်မနေ တက်ရောက်ရပါသည်။</p>
            <p class="text-justify myanmar-text">ဤမိတ်ဆက်သင်တန်းမှတစ်ဆင့် ဆရာ၊ ဆရာမများနှင့် ဝန်ထမ်းများအားလုံးသည်
              ကျောင်း၏ ကလေးသူငယ်ကာကွယ်စောင့်ရှောက်ရေးနှင့် ဘေးကင်းလုံခြုံရေးဆိုင်ရာ စနစ်များ၊ မူဝါဒများ၊ ဖြစ်စဉ်များကို
              တင်ပြရမည့်လုပ်ထုံးလုပ်နည်းများနှင့် မိမိတို့၏ တာဝန်များကို ကောင်းစွာ နားလည်သဘောပေါက်ပြီး
              ကလေးသူငယ်များအပေါ် အနိုင်ကျင့်ခြင်း၊ အလွဲသုံးစားပြုခြင်း သို့မဟုတ် လျစ်လျူရှုခြင်း စသည့် လက္ခဏာများကို
              ကြိုတင် သတိပြုဖော်ထုတ်နိုင်ရန် လိုအပ်သော အသိပညာ၊ နားလည်မှုနှင့် ကျွမ်းကျင်မှုများ ရရှိစေရန်လည်း
              ရည်ရွယ်ပါသည်။</p>
            <p class="text-justify myanmar-text">ဘေးကင်းလုံခြုံရေးအတွက် မြင့်မားသော စံနှုန်းများကို စဉ်ဆက်မပြတ်
              ထိန်းသိမ်းနိုင်ရန် သင်တန်းများကို နှစ်စဉ်ပြန်လည်ပို့ချပေးပြီး နိုင်ငံတကာ၏ လက်ရှိအကောင်းဆုံး
              လုပ်ထုံးလုပ်နည်းများ၊ စံနှုန်းများနှင့်အညီ မွမ်းမံလျက်ရှိပါသည်။ ထိုသို့ စနစ်တကျ ဆောင်ရွက်ခြင်းဖြင့် ဆရာ၊
              ဆရာမများနှင့် ဝန်ထမ်းများသည် ကျောင်းသား၊ ကျောင်းသူတိုင်း၏ ဘေးကင်းလုံခြုံမှုနှင့် ကျန်းမာပျော်ရွှင်စွာ
              ဖွံ့ဖြိုးတိုးတက်နိုင်ရေးကို ထိရောက်စွာ ကာကွယ်စောင့်ရှောက်နိုင်ရန် လိုအပ်သော အသိပညာနှင့်
              ကျွမ်းကျင်မှုများကို အစဉ်ထိန်းသိမ်းထားနိုင်မည် ဖြစ်ပါသည်။</p>
          </div>

          <div v-if="activeTab === 2" class="burmese-content">
            <p class="text-justify myanmar-text">ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်းတွင် ကျောင်းရှိ ကျောင်းသား၊
              ကျောင်းသူများ၊ ဆရာ၊ဆရာမများနှင့် ဝန်ထမ်းများ၏ ကိုယ်စိတ်နှလုံး ကျန်းမာပျော်ရွှင်ရေး ကို အလေးအနက်ထား
              ဆောင်ရွက်လျက်ရှိပြီး အားပေးကူညီမှုရှိသော ကျောင်းပတ်ဝန်းကျင်တစ်ရပ်ကို ဖန်တီးပေးရန် ရည်ရွယ်ပါသည်။</p>
            <p class="text-justify myanmar-text">ကျောင်းသား၊ ကျောင်းသူများ၊ ဆရာ၊ဆရာမများ နှင့် ဝန်ထမ်းများ၏
              လူမှုဆက်ဆံရေးနှင့် စိတ်ပိုင်းဆိုင်ရာအဆင်မပြေမှုဖြစ်စဉ်များ၊ စိုးရိမ်ဖွယ်ရာကိစ္စရပ်များကို
              မှတ်တမ်းတင်ခြင်းနှင့် စနစ်တကျ စောင့်ကြည့်ခြင်း ဆိုင်ရာ လုပ်ထုံးလုပ်နည်းများကို ချမှတ်ထားပြီး တင်ပြလာသည့်
              ကိစ္စရပ်တိုင်းကို အနီးကပ်စောင့်ကြည့်ကာ လိုအပ်သည့် အထောက်အပံ့များကို အချိန်နှင့်တစ်ပြေးညီ လုပ်ဆောင်နိုင်ရန်
              ဆောင်ရွက်ထားပါသည်။</p>
            <p class="text-justify myanmar-text">ဤစနစ်နှင့်လုပ်ထုံးလုပ်နည်းများကို မြန်မာနိုင်ငံ၏
              ကလေးသူငယ်အခွင့်အရေးများဆိုင်ရာဥပဒေများ၊ နိုင်ငံတကာစံနှုန်းများနှင့် အညီ လိုက်နာဆောင်ရွက်နိုင်ရန်၊
              ကျောင်းတွင်းအခြေအနေနှင့် လိုအပ်ချက်များနှင့် ကိုက်ညီအောင် သင့်လျော်စွာ ပြင်ဆင်အသုံးပြုထားပါသည်။ ထို့အပြင်
              ကလေးသူငယ်ကာကွယ်စောင့်ရှောက်ရေးနှင့် ကိုယ်စိတ်နှလုံး ကျန်းမာပျော်ရွှင်ရေး ဆိုင်ရာ မှတ်တမ်းများအားလုံးကို
              အပြည့်အဝ ထိန်းသိမ်းနိုင်ရန် လုံခြုံစိတ်ချရသော Child Protection Monitoring System (CPOMs)
              ကိုအသုံးပြုထားပါသည်။</p>
            <p class="text-justify myanmar-text">ထိုသို့ ကျောင်းသား၊ ကျောင်းသူများ၊ ဆရာ၊ဆရာမများ နှင့် ဝန်ထမ်းများ၏
              ကိုယ်စိတ်နှလုံး ကျန်းမာပျော်ရွှင်ရေးအတွက် ဆောင်ရွက်သည့် အစီအစဉ်များသည် ကျောင်း၏ အဓိကတန်ဖိုးထားမှု
              (မျှော်မှန်းချက်များနှင့် စံချိန်စံညွှန်း) များကို အခြေခံပြီး ဆောင်ရွက်ထားပါသည်။</p>
          </div>

          <div v-if="activeTab === 3" class="burmese-content">
            <p class="text-justify myanmar-text">ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်းတွင် ကျောင်းသား၊ ကျောင်းသူများ၏
              စိတ်ကျန်းမာရေးကိုလည်း အလေးထားဆောင်ရွက်လျက်ရှိပြီး သက်ဆိုင်ရာအတန်းအဆင့်အလိုက် <strong>(မူလတန်းကြိုအဆင့်၊
                မူလတန်းအဆင့်၊ အလယ်တန်းအဆင့်၊ အထက်တန်းအဆင့်)</strong> အကြံပေးဆွေးနွေးသူ (Professional Counsellor) တစ်ဦးစီ
              ထားရှိထားပါသည်။ ထိုသို့ ဆောင်ရွက်ထားခြင်းဖြင့် ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့် ယုံကြည်စိတ်ချရပြီး
              လုံခြုံသော ပတ်ဝန်းကျင်တွင် မိမိတို့၏ ခံစားချက်များကို ပွင့်လင်းစွာ ဆွေးနွေးနိုင်ရန်ဖြစ်သည်။</p>
            <p class="text-justify myanmar-text">ထို့အပြင် အကြံပေးဆွေးနွေးမှုများအတွင်း ကျောင်းသား၊ ကျောင်းသူများက
              မျှဝေပြောကြားသည့် အချက်အလက်များနှင့် ကိုယ်ရေးကိုယ်တာကိစ္စရပ်များကို အချက်အလက် ကာကွယ်ရေး (Data Protection)
              စံနှုန်းများနှင့်အညီ စနစ်တကျ ထိန်းသိမ်းပြီး ကျင့်ဝတ်များနှင့်အညီ ဂရုတစိုက် ကိုင်တွယ်ဆောင်ရွက်လျက်ရှိပါသည်။
            </p>
            <p class="text-justify myanmar-text">ဤအကြံပေးဆွေးနွေးမှုမှတစ်ဆင့် ကျောင်းသား၊ ကျောင်းသူတိုင်း
              လုံခြုံစိတ်ချရပြီး အားပေးကူညီမှုရှိသော ပတ်ဝန်းကျင်တွင် ကောင်းမွန်စွာ ဖွံ့ဖြိုးတိုးတက်နိုင်ရန်
              အထောက်အကူပြုပါသည်။</p>
          </div>
        </div>
      </div>

      <!-- <div class="questions-section">
        <h2 class="questions-heading">
          <span v-if="font_type == 1">Questions</span>
          <span v-if="font_type == 2">မေးခွန်းများ (Questions)</span>
        </h2>

        <div v-if="font_type == 1" class="english-content">
          <h3 class="question-title">1. What subjects are there at school?</h3>
          <p class="text-justify">At Shwe Maw Kun Private School, students enjoy a well-rounded education through the Myanmar National Curriculum, along with a wide range of co-curricular subjects and activities. Depending on the grade level, students study core subjects such as English, Mathematics, Science, Computing, Myanmar, and Social Studies. In addition, students participate in co-curricular subjects and activities that help develop their creativity, critical thinking, communication, leadership, teamwork, and overall personal growth, ensuring a balanced and enriching learning experience.</p>

          <h3 class="question-title">2. What subjects are covered on the Extended Learning Platform, and what are the benefits?</h3>
          <p class="text-justify">Our Extended Learning Platform provides students with continuous access to high-quality learning resources beyond the classroom. It supports subjects including English, Mathematics, Science, Computing, and other curriculum-based lessons, helping students reinforce their understanding at their own pace.</p>
          <p>Benefits of the Extended Learning Platform include:</p>
          <ul>
            <li>24/7 access to learning materials</li>
            <li>Interactive lessons and practice activities</li>
            <li>Revision support for classroom learning</li>
            <li>Opportunities for independent learning</li>
            <li>Regular progress monitoring and academic improvement</li>
            <li>Greater flexibility for students and parents</li>
          </ul>
          <p class="text-justify">The platform helps students build confidence, strengthen their knowledge, and develop lifelong learning habits.</p>

          <h3 class="question-title">3. What about Olympiad competitions—can we participate in those too?</h3>
          <p class="text-justify">Shwe Maw Kun Private School encourages students to participate in International Olympiad Competitions. These competitions provide students with valuable opportunities to challenge themselves academically, showcase their talents, and gain international exposure.</p>
          <p>Participating in Olympiads helps students:</p>
          <ul>
            <li>Develop higher-order thinking and problem-solving skills</li>
            <li>Build confidence through healthy academic competition</li>
            <li>Gain international recognition and achievement</li>
            <li>Prepare for future academic success</li>
          </ul>
          <p class="text-justify">We are proud to support and guide our students throughout their Olympiad journey and encourage every eligible student to participate.</p>
        </div>

        <div v-if="font_type == 2" class="burmese-content">
          <h3 class="question-title-burmese">၁။ ကျောင်းတွင် မည်သည့်ဘာသာရပ်များကို သင်ကြားပေးပါသလဲ?</h3>
          <p class="text-justify myanmar-text">ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်းတွင် ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့် မြန်မာနိုင်ငံအမျိုးသားသင်ရိုးညွှန်းတမ်း (Myanmar National Curriculum) ကို အခြေခံ၍ သင်ယူကြပြီး၊ ဘက်စုံဖွံ့ဖြိုးတိုးတက်စေရန်အတွက် ထပ်ဆောင်း ဘာသာရပ်များ (Co-curricular Subjects and Activities) ကိုလည်း စီစဉ်ပေးထားပါသည်။ အတန်းအဆင့်အလိုက် မြန်မာစာ၊ အင်္ဂလိပ်စာ၊ သင်္ချာ၊ သိပ္ပံ၊ လူမှုရေးနှင့် ကွန်ပျူတာ ဘာသာရပ်များကို အဓိကထားသင်ကြားပေးပါသည်။</p>
          <p class="text-justify myanmar-text">အဆိုပါ သင်ကြားသင်ယူမှု အခွင့်အလမ်းများမှတစ်ဆင့် တီထွင်ဖန်တီးနိုင်စွမ်း၊ ဝေဖန်ပိုင်းခြားတွေးခေါ်နိုင်စွမ်း၊ ဆက်သွယ်ပြောဆိုနိုင်စွမ်း၊ ခေါင်းဆောင်မှုနှင့် အဖွဲ့လိုက်ပူးပေါင်းဆောင်ရွက်နိုင်စွမ်းတို့ကို ဖွံ့ဖြိုးတိုးတက်စေရန် အထောက်အကူပြုပါသည်။</p>

          <h3 class="question-title-burmese">၂။ Extended Learning Platform တွင် မည်သည့်ဘာသာရပ်များကို လေ့လာနိုင်ပြီး မည်သည့်အကျိုးကျေးဇူးများ ရရှိနိုင်ပါသလဲ?</h3>
          <p class="text-justify myanmar-text">Extended Learning Platform မှတစ်ဆင့် ကျောင်းသား၊ ကျောင်းသူများသည် စာသင်ခန်းအတွင်း သင်ယူရရှိထားသည့် အကြောင်းအရာများကို စာသင်ချိန်ပြင်ပတွင်လည်း ဆက်လက်လေ့လာနိုင်ရန် စီစဉ်ပေးထားသော သင်ယူမှုပလက်ဖောင်းတစ်ခု ဖြစ်ပါသည်။ ဤပလက်ဖောင်းတွင် အင်္ဂလိပ်စာ၊ သင်္ချာ၊ သိပ္ပံ၊ ကွန်ပျူတာစသည့် သင်ခန်းစာများ ပါဝင်ပြီး၊ ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့် မိမိတို့အဆင်ပြေသည့် အချိန်တွင် လေ့လာသင်ယူနိုင်ရန်ရည်ရွယ်ပါသည်။</p>
          <p class="myanmar-text">Extended Learning Platform ၏ အကျိုးကျေးဇူးများ</p>
          <ul class="myanmar-list">
            <li>သင်ခန်းစာများကို အချိန်မရွေး လေ့လာနိုင်ခြင်း</li>
            <li>စိတ်ပါဝင်စားမှုရှိစေရန်လှုံ့ဆော်ပေးသော သင်ယူမှုပုံစံဖြင့်လေ့လာနိုင်ခြင်း</li>
            <li>သင်ယူထားသောသင်ခန်းစာများကို ပြန်လည်လေ့လာနိုင်ရန် အထောက်အကူပြုခြင်း</li>
            <li>မိမိကိုယ်တိုင် လေ့လာသင်ယူနိုင်သည့် အလေ့အကျင့်ကောင်းများ တိုးတက်လာခြင်း</li>
            <li>သင်ယူမှုဆိုင်ရာတိုးတက်မှု မှတ်တမ်းများကို စဉ်ဆက်မပြတ်စောင့်ကြည့်ခြင်း</li>
          </ul>
          <p class="text-justify myanmar-text">တို့ကိုအထောက်အကူပြုပါသည်။</p>

          <h3 class="question-title-burmese">၃။ နိုင်ငံတကာ အိုလံပစ် ပြိုင်ပွဲများတွင်လည်း ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့် ပါဝင်ယှဉ်ပြိုင်နိုင်ပါသလား?</h3>
          <p class="text-justify myanmar-text">ရွှေမော်ကွန်း ကိုယ်ပိုင်ကျောင်းတွင် ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့် နိုင်ငံတကာအိုလံပစ် ပြိုင်ပွဲများ (International Olympiad Competitions) တွင် ပါဝင်ယှဉ်ပြိုင်နိုင်ရန် အားပေးကူညီပေးလျက်ရှိပါသည်။ အဆိုပါပြိုင်ပွဲများသည် ကျောင်းသား၊ ကျောင်းသူများအနေဖြင့် မိမိတို့၏ ပညာရပ်ဆိုင်ရာစွမ်းရည်များကို စမ်းသပ်မြှင့်တင်နိုင်ရန်၊ မိမိတို့၏ ထူးချွန်မှုများကို ဖော်ထုတ်ပြသနိုင်ရန်နှင့် နိုင်ငံတကာအဆင့်တွင် အတွေ့အကြုံများ ရရှိနိုင်ရန် အဖိုးတန်အခွင့်အလမ်းများကို ပေးစွမ်းပါသည်။</p>
          <p class="myanmar-text">အိုလံပစ် ပြိုင်ပွဲများတွင် ပါဝင်ယှဉ်ပြိုင်ခြင်းဖြင့်—</p>
          <ul class="myanmar-list">
            <li>တွေးခေါ်မှုနှင့် ပြဿနာဖြေရှင်းနိုင်စွမ်းများ တိုးတက်လာစေခြင်း</li>
            <li>ပညာရပ်ဆိုင်ရာ ယှဉ်ပြိုင်မှုများမှတစ်ဆင့် မိမိကိုယ်ကို ယုံကြည်မှု တိုးတက်လာစေခြင်း</li>
            <li>နိုင်ငံတကာအဆင့် အသိအမှတ်ပြုမှုနှင့် ထူးချွန်အောင်မြင်မှုများ ရရှိနိုင်ခြင်း</li>
            <li>အနာဂတ်ပညာရေးအောင်မြင်မှုများအတွက် ကြိုတင်ပြင်ဆင်ပေးနိုင်ခြင်း</li>
          </ul>
          <p class="text-justify myanmar-text">တို့ကို အထောက်အကူပြုပါသည်။ သတ်မှတ်ချက်များနှင့် ကိုက်ညီသော ကျောင်းသား၊ ကျောင်းသူတိုင်း ပြိုင်ပွဲများတွင် ပါဝင်ယှဉ်ပြိုင်ရန်လည်း အားပေးတိုက်တွန်းလျက်ရှိပြီး အိုလံပစ်ပြိုင်ပွဲတွင် ပါဝင်ယှဉ်ပြိုင်သည့် လမ်းကြောင်းတစ်လျှောက် လိုအပ်သည့် လမ်းညွှန်မှုနှင့် ပံ့ပိုးကူညီမှုများကို ပေးနိုင်ရန် အလေးထား ဆောင်ရွက်လျက်ရှိပါသည်။</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 1
    };
  },
  computed: {
    font_type() {
      return this.$store.state.font_type;
    }
  },
  mounted() { }
};
</script>

<style lang="scss" scoped>
.safeguarding-page {
  padding: 40px 0;
  background-color: #ffffff;
}

.content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.tabs-wrapper {
  margin-bottom: 30px;
}

.tabs-row {
  display: flex;
  gap: 4px;
  flex-wrap: nowrap;
  overflow-x: auto;
  align-items: flex-end;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.tab-btn {
  flex: 0 0 auto;
  padding: 20px 28px;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.6;
  color: #2c1838;
  background-color: #c0a5c0;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  border-top-left-radius: 18px;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  &.active {
    background-color: #ffd700;
    color: #1a0f22;
    font-weight: 700;
  }
}

.tabs-bottom-border {
  height: 6px;
  background-color: #5e1f72;
  margin-top: 0;
  border-radius: 0;
}

.content-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 40px;
  margin-bottom: 60px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-image {
  float: right;
  width: 470px;
  max-width: 55%;
  height: auto;
  margin-left: 36px;
  margin-bottom: 28px;
  margin-top: 0;
  border-top-left-radius: 14px;
  border-top-right-radius: 0;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 0;
  object-fit: cover;
  box-shadow: 0 8px 20px rgba(91, 44, 111, 0.32);
}

.card-title {
  font-size: 34px;
  font-weight: 900;
  color: #671259;
  text-align: left;
  margin-top: 0;
  margin-bottom: 30px;
  line-height: 1.4;
}

.english-content,
.burmese-content {
  h3 {
    font-size: 20px;
    font-weight: 700;
    color: #2c3e50;
    margin-top: 25px;
    margin-bottom: 12px;
    line-height: 1.4;
  }

  p {
    font-size: 17px;
    line-height: 1.8;
    margin-bottom: 18px;
    margin-left: 20px;
    color: #2c3e50;
  }

  ul {
    margin: 15px 0 20px 25px;

    li {
      font-size: 17px;
      line-height: 1.8;
      margin-bottom: 8px;
      color: #2c3e50;
      list-style-type: disc;
    }
  }
}

.english-content {
  p {
    text-indent: 40px;
  }
}

.burmese-content {
  p {
    text-indent: 40px;
  }
}

.text-justify {
  text-align: justify;
}

.question-title {
  color: #1a5276;
}

.question-title-burmese {
  color: #1a5276;
}

.myanmar-text {
  line-height: 32px;
}

.myanmar-list {
  margin: 15px 0 20px 25px;

  li {
    line-height: 32px;
    margin-bottom: 8px;
  }
}

.questions-section {
  .questions-heading {
    font-size: 30px;
    font-weight: 900;
    color: #5b2c6f;
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 14px;
    border-bottom: 3px solid #f0e68c;
  }
}

@media (max-width: 768px) {
  .safeguarding-page {
    padding: 20px 0;
  }

  .tabs-row {
    flex-direction: row;
    gap: 2px;
  }

  .tab-btn {
    font-size: 11px;
    padding: 12px 10px;
    border-top-left-radius: 12px;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .tabs-bottom-border {
    height: 4px;
  }

  .content-card {
    padding: 20px;
    margin-bottom: 40px;
  }

  .card-image {
    width: 290px;
    max-width: 55%;
    margin-left: 20px;
    margin-bottom: 16px;
    border-top-left-radius: 12px;
    border-top-right-radius: 0;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 0;
  }

  .card-title {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .english-content,
  .burmese-content {
    h3 {
      font-size: 18px;
    }

    p {
      font-size: 15px;
      line-height: 1.7;
      margin-left: 14px;
    }

    ul {
      margin-left: 20px;

      li {
        font-size: 15px;
      }
    }
  }

  .english-content {
    p {
      text-indent: 28px;
    }
  }

  .burmese-content {
    p {
      text-indent: 28px;
    }
  }

  .myanmar-text {
    line-height: 28px;
  }

  .myanmar-list {
    li {
      line-height: 28px;
    }
  }

  .questions-section {
    .questions-heading {
      font-size: 22px;
      margin-bottom: 20px;
    }
  }
}
</style>
